import { flowRight } from 'lodash';
import { useDocumentFootnotes } from '../../../../context/DocumentFootnotesContext';
import withDialog from '../../../WithDialog';
import FastValueViewer from '../FastValueViewer';
import ReferencesValueViewerProps from './ReferencesValueViewer.props';
import { StyledHtmlTooltip } from './ReferencesValueViewer.styles';

const ReferencesValueViewer = (props: ReferencesValueViewerProps) => {
  const { mappingReferences } = props.cell as any;
  const { documentSourceMap } = useDocumentFootnotes();

  // Build tooltip content showing all references
  const tooltipContent =
    mappingReferences
      ?.map((ref: any) => {
        const cellRefs = ref.cell_references?.map((cr: any) => cr.ref).join(', ') || '';
        return `Source: ${documentSourceMap.get(ref.document_reference)} - Sheet: ${ref.sheet_name} - Cells: ${cellRefs}`;
      })
      .join('\n') || 'Mapped from source document';

  // return ;

  return (
    <StyledHtmlTooltip title={tooltipContent} placement="top" arrow>
      <div>
        <FastValueViewer {...props} />
      </div>
    </StyledHtmlTooltip>
  );
};

const enhancements = flowRight(withDialog);
export default enhancements(ReferencesValueViewer);
